import Vue from 'vue'
import numeral from 'numeral';
import store from '@/plugins/store'

//- Filters 
Vue.filter('date', value => {
  if (!value) {return ''}
  const date = new Date(value)
  return date.getFullYear() + '-' + 
    ((date.getMonth() < 9) ? '0' : '') + (date.getMonth() + 1) + '-' +
    ((date.getDate() < 10) ? '0' : '') + date.getDate();
})

Vue.filter('nf', value => {
  const l = store.getters["app/locale"]
  if (l==="en") {
    return numeral(value)
      .format('0,0.00')
  }
  return numeral(value)
    .format('0,0.00')
    .replace(/,/g,' ')
})
